import { Dispatch, SetStateAction } from 'react'
import TextField from '@mui/material/TextField'
import { IIncidentReportFormData } from '../IncidentReportModal'
import styles from '../styles.module.css'

interface IRecommendationsTabProps {
  formData: IIncidentReportFormData
  setFormData: Dispatch<SetStateAction<IIncidentReportFormData>>
}

function RecommendationsTab({ formData, setFormData }: IRecommendationsTabProps) {
  function handleChange(field: keyof IIncidentReportFormData, value: any) {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  return (
    <div className={styles.formContainer}>
      <TextField
        label='Recommendations'
        value={formData.recommendations}
        onChange={(e) => handleChange('recommendations', e.target.value)}
        multiline
        rows={12}
        fullWidth
        placeholder='Provide recommended follow-up actions based on this incident.'
      />
    </div>
  )
}

export default RecommendationsTab
